import { CONNECT_INPUT_ID } from './constants'

export const focusInput = (inputId: CONNECT_INPUT_ID, shouldScrollToElement?: boolean, element?: Element) => {
  setTimeout(() => document.getElementById(inputId)?.focus(), 450)
  if (shouldScrollToElement && element) {
    // Scroll to form on input focus so that the fields + buttons are visible even with a mobile keyboard opened
    element.scrollIntoView() //DO NOT PUT OPTIONS HERE! scroolIntoView options are not compatible with IOS.
  }
}

export const trimData = <T extends Record<string, string>>(data: T) =>
  Object.entries(data).reduce((acc, [key, value]) => ({ ...acc, [key]: value?.trim() }), {} as T)
